<template>
  <v-card class="assignment-form">
    <div class="d-flex align-center justify-space-between assignment-form__title">
      <p class="assignment-form__title--left">
        Assignment <span v-if="gIsEditing && checkIfFieldUpdated">[UNSAVED CHANGES]</span>
        <span v-if="!gIsEditing">[DRAFT]</span>
      </p>
      <div class="d-flex align-center assignment-form__title--right">
        <p class="assignment-form__title--right--text ml-5" v-if="gIsEditing && windowWidth > 925 && createdOnText">
          {{ createdOnText }}
        </p>
        <!-- <p class="assignment-form__title--right--text ml-5" v-if="!gIsEditing && windowWidth > 925">The task is in DRAFT. To save your changes, publish the task.</p> -->
        <button v-if="createAssignmentLoader"
          class="assignment-form__title--right--publish ml-2"
          disabled>
            Saving…
        </button>
        <button v-else-if="!gIsEditing"
          class="assignment-form__title--right--publish ml-2"
          @click.prevent="publishAssignment">
            Publish Assignment
        </button>
        <button v-else-if="gIsEditing && checkIfFieldUpdated"
          class="assignment-form__title--right--publish ml-2"
          @click.prevent="publishAssignment">
            Update
        </button>
        <div class="assignment-form__title--right--delimetr ml-5"></div>
        <div class="assignment-form__title--right--icon ml-5">
          <v-btn
            text
            small
            @click.native.stop.prevent="openSlackForm(itemToEdit)">
            <pmdashboard_table_icons
              :icon="'pmdashboard_slack'"
              />
          </v-btn>
        </div>
        <div class="assignment-form__title--right--icon ml-5" v-if="canEditMainFields">
          <v-btn
            text
            small
            @click.native.stop.prevent="openSettingsMenu">
            <pmdashboard_table_icons
              :icon="'pmdashboard_ellipsis-solid'"
              />
          </v-btn>
          <div
            v-if="assignmentSettingsMenu"
            class="assignment-form__title--right--menu"
            v-click-outside="closeSettingsMenu">
            <div class="assignment-form__title--right--menu--items">
              <p v-if="canEditMainFields" @click="deleteAssignment">Delete assignment</p>
            </div>
          </div>
        </div>
        <div class="assignment-form__title--right--close ml-2">
          <v-btn
            text
            small
            @click="requestClose">
            <pmdashboard_table_icons
              :icon="'pmdashboard_close_black'"
              />
          </v-btn>
        </div>
      </div>
    </div>
    <v-container class="assignment-form__assignment pa-0" fluid>
      <div class="row-styles w-100 ma-0">
        <div
          :style="windowWidth <= 1286 || !canSeeSidePanels
            ? { width: '100%' }
            : { width: 'calc(100% - 420px)' }"
          class="assignment-form__assignment--content-left" 
          :class="{ 'pa-1': windowWidth > 1286,
            'pa-0': windowWidth <= 1286
           }">
          <div class="d-flex w-100">
            <div style="width: 100%;" 
              class="scrollable-col animated-section"
              v-show="settingsSection === 'Details'"
              :style="dynamicHeightStyle">
              <div class="d-flex flex-column assignment-form__assignment--title pa-6 ml--12px assignment-form__assignment--title--narrow"
                style="
                margin-top: 0;
                padding-top: 50px !important;
                "
              >

                <!-- Cue Task ID + Cue Assignment ID + External Assignment ID -->
                <div class="d-flex w-100 relative">
                  <span
                    class="assignment-form--id--switch d-flex align-center"
                    @click.stop.prevent="toggleHeaderDropdown"
                  >
                    <p class="assignment-form--id--text d-inline mb-0">{{ headerDropdown.find(item => item.show).title }}</p>
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_arrow_down'"
                      class="assignment-form--id--caret"
                      />
                  </span>
                  <v-btn
                    v-if="headerDropdown.find(item => item.show).value"
                    text
                    small
                    class="assignment-form--id--button"
                    @click.native.stop.prevent="copyTaskId">
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_copy'"
                      />
                  </v-btn>
                  <input
                    v-if="isEditing.includes('editableInput-headerId') && shownHeaderId.field"
                    type="text"
                    ref="editableInput-headerId"
                    :value="shownHeaderId.value"
                    class="input-field input-field-idNumber bradius-4"
                    @input="updateAssignmentData({ field: shownHeaderId.field, data: $event.target.value })"
                    @blur="stopEditing('editableInput-headerId')"
                    @keydown.enter="stopEditing('editableInput-headerId')"
                  />
                  <p
                    v-else
                    class="mb-0 assignment-form--id--value"
                    :class="{
                      'assignment-form--id--value--editable': headerIdEditable,
                      'hover': headerIdEditable && isHovered.includes('editableInput-headerId'),
                    }"
                    @mouseenter="headerIdEditable && isHoveredOn('editableInput-headerId')"
                    @mouseleave="isHoveredOff('editableInput-headerId')"
                    @click="beginEditingHeaderId"
                  >
                    {{ shownHeaderId.value ? shownHeaderId.value : 'no value yet' }}
                  </p>
                  <div class="assignment-form__header--dropdown"
                    v-click-outside="toggleHeaderDropdown"
                    v-if="headerDropdownState">
                    <div class="dropdown-item"
                      v-for="(item, index) in headerDropdown"
                      :key="index"
                      @click.prevent="selectDropdownItem(item)">
                      <div class="dropdown-item--left">
                        <p class="dropdown-item--left--text">{{ item.title }}</p>
                        <div class="dropdown-item--left--value">
                          <v-btn
                            v-if="item.value"
                            text
                            small
                            class="assignment-form--id--button"
                            @click.native.stop.prevent="copyTaskId">
                            <pmdashboard_table_icons
                              :icon="'pmdashboard_copy'"
                              />
                          </v-btn>
                          <p class="mb-0 dropdown-item--left--value--text">{{ item.value ? item.value : 'no value yet' }}</p>
                        </div>
                      </div>
                      <div class="dropdown-item--right" style="flex: 0 0 auto;">
                        <v-icon 
                          v-if="item.show"
                          size="20"
                          style="margin-left: 3.5px;">
                            mdi-check
                        </v-icon>
                      </div>
                    </div>
                  </div>
                  <!-- <div
                    v-if="!isEditing.includes('editableInput-assignmentForm.taskId')"
                    class="mb-0 assignment-form--id w-100 bradius-4"
                    :class="{
                      'hover': isHovered.includes('editableInput-assignmentForm.taskId'),
                      'empty-p-field-assignmentForm.taskId': !assignmentForm.taskId,
                      'fullfield-p-field-assignmentForm.taskId': assignmentForm.taskId
                    }"
                    style="position: relative;"
                    @mouseover="isHoveredOn('editableInput-assignmentForm.taskId')"
                    @mouseleave="isHoveredOff('editableInput-assignmentForm.taskId')"
                    @click="startEditing('editableInput-assignmentForm.taskId')"
                  >
                    <p style="width: 90%" class="mb-0">
                      {{ assignmentForm.taskId ? assignmentForm.taskId : '-' }}
                    </p>
                    <span
                      @click.prevent.stop="assignmentForm.taskId = ''"
                      class="assignment-form__clear assignment-form__clear--title"
                      v-if="isHovered.includes('editableInput-assignmentForm.taskId') && assignmentForm.taskId"
                    >
                      <pmdashboard_table_icons
                        :icon="'pmdashboard_clear_text_field'"
                        class="assignment-form__clear-text d-block"
                      />
                    </span>
                  </div>
                  <input
                    v-else
                    type="text"
                    ref="editableInput-assignmentForm.taskId"
                    v-model="assignmentForm.taskId"
                    @blur="stopEditing('editableInput-assignmentForm.taskId')"
                    @keydown.enter="stopEditing('editableInput-assignmentForm.taskId')"
                    :class="{ hover: true }"
                    class="input-field input-field-assignmentForm.taskId w-100 bradius-4"
                  /> -->
                </div>

                <!-- Assignment Detail is the headline of the card: it is the
                description the dashboard table and the Slack notification show,
                so it is what identifies the assignment at a glance. The
                Assignment Title reads underneath as the secondary line. Detail
                used to sit in the Main tab's field list; it lives here now. -->
                <div class="d-flex align-center w-100 assignment-form--title">
                  <v-btn
                    text
                    small
                    class="assignment-form--title--button"
                    @click.native.stop.prevent="copyAssignmentDetail">
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_copy'"
                      />
                  </v-btn>
                  <div
                    v-if="!isEditing.includes('editableInput-assignmentDetail')"
                    class="mb-0 w-100 assignment-form--title--div bradius-4"
                    :class="{
                      'hover': isHovered.includes('editableInput-assignmentDetail'),
                      'assignment-form--placeholder': !assignmentForm.assignmentDetail,
                      'error-color': isInvalid('assignmentDetail'),
                      'shake': isInvalid('assignmentDetail'),
                    }"
                    style="position: relative;"
                    @mouseenter="isHoveredOn('editableInput-assignmentDetail')"
                    @mouseleave="isHoveredOff('editableInput-assignmentDetail')"
                    @click="startEditing('editableInput-assignmentDetail')"
                  >
                    <p style="width: 90%; white-space: normal; word-wrap: break-word;" class="mb-0">
                      {{ assignmentForm.assignmentDetail ? assignmentForm.assignmentDetail : 'No Detail' }}
                    </p>
                    <span
                      @click.stop.prevent="updateAssignmentData({ field: 'assignmentDetail', data: '' })"
                      class="assignment-form__clear assignment-form__clear--title"
                      v-if="isHovered.includes('editableInput-assignmentDetail') && assignmentForm.assignmentDetail"
                    >
                      <pmdashboard_table_icons
                        :icon="'pmdashboard_clear_text_field'"
                        class="assignment-form__clear-text d-block"
                      />
                    </span>
                  </div>
                  <input
                    v-else
                    type="text"
                    ref="editableInput-assignmentDetail"
                    v-model="assignmentDetailValue"
                    @blur="stopEditing('editableInput-assignmentDetail')"
                    @keydown.enter="stopEditing('editableInput-assignmentDetail')"
                    :class="{ hover: true }"
                    class="input-field input-field-assignmentDetail w-100 bradius-4"
                  />
                </div>

                <!-- Assignment Title -->
                <div class="d-flex align-center w-100 assignment-form--subtitle">
                  <v-btn
                    text
                    small
                    class="assignment-form--subtitle--button"
                    @click.native.stop.prevent="copyAssignmentTitle">
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_copy'"
                      />
                  </v-btn>
                  <div
                    v-if="!isEditing.includes('editableInput-assignmentTitle')"
                    class="mb-0 w-100 assignment-form--subtitle--div bradius-4"
                    :class="{
                      'hover': isHovered.includes('editableInput-assignmentTitle'),
                      'assignment-form--placeholder': !assignmentForm.assignmentTitle,
                      'error-color': isInvalid('assignmentTitle'),
                      'shake': isInvalid('assignmentTitle'),
                    }"
                    style="position: relative;"
                    @mouseenter="isHoveredOn('editableInput-assignmentTitle')"
                    @mouseleave="isHoveredOff('editableInput-assignmentTitle')"
                    @click="startEditing('editableInput-assignmentTitle')"
                  >
                    <p style="width: 90%; white-space: normal; word-wrap: break-word;" class="mb-0">
                      {{ assignmentForm.assignmentTitle ? assignmentForm.assignmentTitle : 'No Name' }}
                    </p>
                    <span
                      @click.stop.prevent="updateAssignmentData({ field: 'assignmentTitle', data: '' })"
                      class="assignment-form__clear assignment-form__clear--title"
                      v-if="isHovered.includes('editableInput-assignmentTitle') && assignmentForm.assignmentTitle"
                    >
                      <pmdashboard_table_icons
                        :icon="'pmdashboard_clear_text_field'"
                        class="assignment-form__clear-text d-block"
                      />
                    </span>
                  </div>
                  <input
                    v-else
                    type="text"
                    ref="editableInput-assignmentTitle"
                    v-model="assignmentTitleValue"
                    @blur="stopEditing('editableInput-assignmentTitle')"
                    @keydown.enter="stopEditing('editableInput-assignmentTitle')"
                    :class="{ hover: true }"
                    class="input-field input-field-assignmentTitle w-100 bradius-4"
                  />
                </div>

                <div class="d-flex w-100">
                  <!-- Request Type -->
                  <div class="d-flex relative flex-shrink-0">
                    <p class="assignment-form--id--text d-inline mb-0"
                      :class="{ 'error-color': isInvalid('requestType'),
                        'shake': isInvalid('requestType') }">Request Type:&nbsp;</p>
                    <p class="mb-0 assignment-form--id--value assignment-form--id--value--editable"
                      @click.prevent="toggleRequestTypeDropdown">
                      {{ assignmentForm.requestType ? assignmentForm.requestType : 'no value yet' }}
                    </p>
                    <div class="assignment-form__header--dropdown dropdown__request pt-0"
                      v-click-outside="toggleRequestTypeDropdown"
                      v-if="requestTypeDropdown">
                      <!-- The list is long enough that scanning it is slower
                      than typing, so it searches like the GEO pickers do. -->
                      <div class="dropdown-item search-container-wrapper">
                        <div class="search-container">
                          <v-icon class="icon">mdi-magnify</v-icon>
                          <input
                            :ref="'search-requestTypeDropdown'"
                            type="text"
                            placeholder="Start typing"
                            v-model="searchRequestTypeDropdown"
                          >
                        </div>
                      </div>
                      <div class="dropdown-item"
                        v-for="(item, index) in requestTypeFiltered"
                        :key="index"
                        @click.prevent="selectRequestTypeDropdownItem(item)">
                        <div class="dropdown-item--left">
                          <p class="dropdown-item--left--text">{{ item }}</p>
                        </div>
                        <div class="dropdown-item--right">
                          <v-icon 
                            v-if="assignmentForm.requestType === item"
                            size="20"
                            style="margin-left: 3.5px;">
                              mdi-check
                          </v-icon>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Assignment Type -->
                  <div class="d-flex relative flex-grow-1">
                    <p class="assignment-form--id--text d-inline mb-0">&nbsp;|&nbsp;Assignment Type:&nbsp;</p>
                    <p class="mb-0 assignment-form--id--value assignment-form--id--value--editable"
                      @click.prevent="toggleAssignmentTypeDropdown">
                      {{ assignmentForm.assignmentType ? assignmentForm.assignmentType : 'no value yet' }}
                    </p>
                    <div class="assignment-form__header--dropdown dropdown__request pt-0"
                      v-click-outside="toggleAssignmentTypeDropdown"
                      v-if="assignmentTypeDropdown">
                      <!-- The list is long enough that scanning it is slower
                      than typing, so it searches like the GEO pickers do. -->
                      <div class="dropdown-item search-container-wrapper">
                        <div class="search-container">
                          <v-icon class="icon">mdi-magnify</v-icon>
                          <input
                            :ref="'search-assignmentTypeDropdown'"
                            type="text"
                            placeholder="Start typing"
                            v-model="searchAssignmentTypeDropdown"
                          >
                        </div>
                      </div>
                      <div class="dropdown-item"
                        v-for="(item, index) in assignmentTypeFiltered"
                        :key="index"
                        @click.prevent="selectAssignmentTypeDropdownItem(item)">
                        <div class="dropdown-item--left">
                          <p class="dropdown-item--left--text">{{ item }}</p>
                        </div>
                        <div class="dropdown-item--right">
                          <v-icon
                            v-if="assignmentForm.assignmentType === item"
                            size="20"
                            style="margin-left: 3.5px;">
                              mdi-check
                          </v-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- GEOs -->
                <div class="d-flex w-100 mt-3">
                  <div class="d-flex relative flex-shrink-0">
                    <p class="mb-0 assignment-form--geo"
                      @click.prevent="toggleSourceGeoDropdown">
                      {{ assignmentForm.sourceGeo ? assignmentForm.sourceGeo : 'No Source GEO' }}
                    </p>

                    <div
                      class="assignment-form__header--dropdown dropdown__request pt-0"
                      v-click-outside="toggleSourceGeoDropdown"
                      v-if="sourceGeoDropdown"
                    >
                      <div class="dropdown-item search-container-wrapper">
                        <div class="search-container">
                          <v-icon class="icon">mdi-magnify</v-icon>
                          <input
                            :ref="'search-sourceGeoDropdown'"
                            type="text"
                            placeholder="Start typing"
                            v-model="searchSourceGeoDropdown"
                          >
                        </div>
                      </div>
                      <div class="dropdown-list">
                        <div class="dropdown-item"
                          v-for="(item, index) in sourceGeoFiltered"
                          :key="index"
                          @click.prevent="selectSourceGeoDropdownItem(item)"
                        >
                          <div class="dropdown-item--left">
                            <p class="dropdown-item--left--text dropdown-item--left--text--geo">
                              {{ item }}
                            </p>
                          </div>
                          <div class="dropdown-item--right">
                            <v-icon
                              v-if="assignmentForm.sourceGeo === item"
                              size="20"
                              style="margin-left: 3.5px;"
                            >
                              mdi-check
                            </v-icon>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="geos--arrow">
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_arrow_right'"
                      />
                  </div>
                  <div class="d-flex relative flex-shrink-0">
                    <p class="mb-0 assignment-form--geo"
                      :class="{ 'error-color': isInvalid('geo'),
                        'shake': isInvalid('geo') }"
                      @click.prevent="toggleGeoDropdown">
                      {{ assignmentForm.geo ? assignmentForm.geo : 'No Target GEO' }}
                    </p>
                    <div
                      class="assignment-form__header--dropdown dropdown__request pt-0"
                      v-click-outside="toggleGeoDropdown"
                      v-if="geoDropdown"
                    >
                      <div class="dropdown-item search-container-wrapper">
                        <div class="search-container">
                          <v-icon class="icon">mdi-magnify</v-icon>
                          <input :ref="'search-geoDropdown'" type="text" placeholder="Start typing" v-model="searchTargetGeoDropdown">
                        </div>
                      </div>
                      <div class="dropdown-list">
                        <div class="dropdown-item"
                          v-for="(item, index) in geoOptionsFiltered"
                          :key="index"
                          @click.prevent="selectGeoDropdownItem(item)"
                        >
                          <div class="dropdown-item--left">
                            <p class="dropdown-item--left--text dropdown-item--left--text--geo">{{ item }}</p>
                          </div>
                          <div class="dropdown-item--right">
                            <v-icon
                              v-if="assignmentForm.geo === item"
                              size="20"
                              style="margin-left: 3.5px;"
                            >
                              mdi-check
                            </v-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  
                <!-- Tabs -->
                <div class="assignment-form__tabs">
                  <div class="assignment-form__tabs--buttons">
                    <button
                      v-for="(tab, index) in tabs"
                      :key="index"
                      :class="['tab-btn', { active: activeTab === index }]"
                      @click="activeTab = index"
                    >
                      {{ tab.label }}
                    </button>
                  </div>
                  <div class="assignment-form__tabs--content">
                    <div class="tabs-slider">
                      <div
                        class="tab-panel"
                        v-for="(tab, index) in tabs"
                        v-show="index === activeTab"
                        :key="index"
                      >
                        <component :is="tab.component"
                          :projectsList="projectsList"
                          :staffList="staffList"
                          :staffHours="staffHours"
                          @assignment-dashboard-table-refresh="handleStaffHoursChanged"
                          @assignment-accepted-changed="captureFormSnapshot" />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- Task/Assignment hierarchy — inline on narrow screens, where the
                 right column collapses into the rail below -->
            <div
              v-if="windowWidth <= 1286 && canSeeSidePanels"
              style="width: 100%;"
              class="animated-section"
              v-show="settingsSection === 'Hierarchy'"
            >
              <ADFormHierarchy
                :taskDbId="assignmentForm.taskDbId"
                :taskId="assignmentForm.taskId"
                :taskName="assignmentForm.taskName"
                :currentAssignmentId="assignmentForm.id"
                @select-assignment="handleHierarchySelect"
              />
            </div>
            <div
              v-if="windowWidth <= 1286 && canSeeSidePanels"
              style="width: 100%;"
              class="animated-section"
              v-show="settingsSection === 'Activity'"
            >
              <ADFormActivity
                :key="`activity-inline-${formActivityUpdate}`"
                :assignmentId="assignmentForm.id"
                :taskDbId="assignmentForm.taskDbId"
              />
            </div>

            <!-- section rail (narrow screens) -->
            <div
              v-if="windowWidth <= 1286"
              class="assignment-form__assignment--settings"
            >
              <div
                class="assignment-form__assignment--settings--button mt-3"
                @click="settingsSection = 'Details'"
              >
                <div
                  class="assignment-form__assignment--settings--button-icon"
                  :style="settingsSection === 'Details' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
                >
                  <pmdashboard_table_icons :icon="'pmdashboard_details2'" />
                </div>
                <p class="mb-0 settings--text">Details</p>
              </div>
              <div
                v-if="canSeeSidePanels"
                class="assignment-form__assignment--settings--button mt-3"
                @click="settingsSection = 'Activity'"
              >
                <div
                  class="assignment-form__assignment--settings--button-icon"
                  :style="settingsSection === 'Activity' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
                >
                  <pmdashboard_table_icons :icon="'pmdashboard_activity'" />
                </div>
                <p class="mb-0 settings--text">Activity</p>
              </div>
              <div
                v-if="canSeeSidePanels"
                class="assignment-form__assignment--settings--button mt-3"
                @click="settingsSection = 'Hierarchy'"
              >
                <div
                  class="assignment-form__assignment--settings--button-icon"
                  :style="settingsSection === 'Hierarchy' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
                >
                  <ad_form_icons :icon="'hierarchy'" />
                </div>
                <p class="mb-0 settings--text">Hierarc.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- right column: panel + section rail (wide screens) -->
        <div
          v-if="windowWidth > 1286 && canSeeSidePanels"
          class="d-flex assignment-form__assignment--right"
          style="width: 420px;"
        >
          <div class="assignment-form__assignment--right--panel">
            <ADFormHierarchy
              v-show="rightPanelSection === 'Hierarchy'"
              ref="hierarchyPanel"
              class="animated-section"
              :taskDbId="assignmentForm.taskDbId"
              :taskId="assignmentForm.taskId"
              :taskName="assignmentForm.taskName"
              :currentAssignmentId="assignmentForm.id"
              @select-assignment="handleHierarchySelect"
            />
            <ADFormActivity
              v-show="rightPanelSection === 'Activity'"
              :key="`activity-panel-${formActivityUpdate}`"
              class="animated-section"
              :assignmentId="assignmentForm.id"
              :taskDbId="assignmentForm.taskDbId"
            />
          </div>
          <div class="assignment-form__assignment--settings assignment-form__assignment--settings--right">
            <div
              class="assignment-form__assignment--settings--button mt-3"
              @click="rightPanelSection = 'Activity'"
            >
              <div
                class="assignment-form__assignment--settings--button-icon"
                :style="rightPanelSection === 'Activity' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
              >
                <pmdashboard_table_icons :icon="'pmdashboard_activity'" />
              </div>
              <p class="mb-0 settings--text">Activity</p>
            </div>
            <div
              class="assignment-form__assignment--settings--button mt-3"
              @click="rightPanelSection = 'Hierarchy'"
            >
              <div
                class="assignment-form__assignment--settings--button-icon"
                :style="rightPanelSection === 'Hierarchy' ? { backgroundColor: '#7575754D' } : { backgroundColor: '#FFF' }"
              >
                <ad_form_icons :icon="'hierarchy'" />
              </div>
              <p class="mb-0 settings--text">Hierarc.</p>
            </div>
          </div>
        </div>
      </div>
    </v-container>

    <!-- leaving the open assignment for a sibling would drop unsaved edits -->
    <v-dialog
      max-width="500"
      v-model="switchConfirmation"
      @click:outside="cancelHierarchySwitch"
      @keydown.esc="cancelHierarchySwitch"
    >
      <div class="assignment-form__confirmation-modal">
        <p class="assignment-form__confirmation-modal--title">Discard changes?</p>
        <p class="assignment-form__confirmation-modal--text">
          There are unsaved changes on this assignment. Opening another assignment
          from the hierarchy will discard them.
        </p>
        <div class="assignment-form__confirmation-modal--buttons d-flex align-center justify-end">
          <v-btn
            text
            class="assignment-form__confirmation-modal--buttons-continue mr-2"
            @click="cancelHierarchySwitch"
          >
            Continue Editing
          </v-btn>
          <v-btn
            depressed
            color="#FF5252"
            class="assignment-form__confirmation-modal--buttons-discard"
            @click="confirmHierarchySwitch"
          >
            Discard Changes
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- closing the card would drop unsaved edits -->
    <v-dialog
      max-width="500"
      v-model="closeConfirmation"
      @click:outside="cancelClose"
      @keydown.esc="cancelClose"
    >
      <div class="assignment-form__confirmation-modal">
        <p class="assignment-form__confirmation-modal--title">Close without saving?</p>
        <p class="assignment-form__confirmation-modal--text">
          This assignment has unsaved changes. Closing the form now will discard
          them.
        </p>
        <div class="assignment-form__confirmation-modal--buttons d-flex align-center justify-end">
          <v-btn
            text
            class="assignment-form__confirmation-modal--buttons-continue mr-2"
            @click="cancelClose"
          >
            Continue Editing
          </v-btn>
          <v-btn
            depressed
            color="#FF5252"
            class="assignment-form__confirmation-modal--buttons-discard"
            @click="confirmClose"
          >
            Discard Changes
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- deleting the assignment is not reversible -->
    <v-dialog
      max-width="500"
      v-model="deleteConfirmation"
      @click:outside="cancelDeleteAssignment"
      @keydown.esc="cancelDeleteAssignment"
    >
      <div class="assignment-form__confirmation-modal">
        <p class="assignment-form__confirmation-modal--title">Delete this assignment?</p>
        <p class="assignment-form__confirmation-modal--text">
          This permanently deletes the assignment and everything recorded against
          it. This cannot be undone.
        </p>
        <div class="assignment-form__confirmation-modal--buttons d-flex align-center justify-end">
          <v-btn
            text
            class="assignment-form__confirmation-modal--buttons-continue mr-2"
            :disabled="deleteProcessing"
            @click="cancelDeleteAssignment"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="#FF5252"
            class="assignment-form__confirmation-modal--buttons-discard"
            :loading="deleteProcessing"
            @click="confirmDeleteAssignment"
          >
            Delete Assignment
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- the pay period this assignment sits in has already been invoiced -->
    <v-dialog
      max-width="500"
      v-model="payPeriodWarning"
      @click:outside="cancelPayPeriodAction"
      @keydown.esc="cancelPayPeriodAction"
    >
      <div class="assignment-form__confirmation-modal">
        <p class="assignment-form__confirmation-modal--title">Warning: Restricted Edit</p>
        <p class="assignment-form__confirmation-modal--text">
          This assignment belongs to a previous pay period and has already been
          invoiced to the client.
          {{ payPeriodIntent === 'delete' ? 'Deleting' : 'Editing' }} this record
          may result in discrepancies. Please contact an administrator before
          proceeding.
        </p>
        <div class="assignment-form__confirmation-modal--buttons d-flex align-center justify-end">
          <v-btn
            text
            class="assignment-form__confirmation-modal--buttons-continue mr-2"
            @click="cancelPayPeriodAction"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="#FF5252"
            class="assignment-form__confirmation-modal--buttons-discard"
            @click="proceedPayPeriodAction"
          >
            Proceed
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- Save outcome, pinned to the bottom edge of the card. Errors carry a
         close button and sit long enough to be read, since the form stays open
         for the user to fix whatever was wrong; a successful save is brief
         because the form closes behind it. -->
    <div class="assignment-form__messages" v-if="alert.status">
      <v-alert
        dense
        text
        :type="alert.type"
        :dismissible="alert.type === 'error'"
        @input="closeAlert"
      >
        {{ alert.message }}
      </v-alert>
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import pmdashboard_table_icons from "@/assets/icons/pmdashboard_table_icons.vue";
import {
  getStaffHoursByAssignmentId,
  getAssignmentById,
  getOneProject,
  // Aliased: this component has its own `deleteAssignment` method, which is what
  // the header menu calls.
  deleteAssignment as deleteAssignmentById,
} from "@/utils/newDbUtils.js";
import { parseAssignmentResponse } from "@/utils/assignmentUtils.js";
import {
  validateAssignmentForm,
  saveAssignmentForm,
  notifyAssignmentSaved,
  syncParentTaskStatus,
  toApiPayPeriod,
} from "@/utils/assignmentFormUtils.js";
import {
  uploadAndAttachDocuments,
  detachAssignmentDocument,
} from "@/utils/assignmentDocumentUtils.js";

import ad_form_icons from "@/assets/icons/ad_form_icons.vue";

import MainTab from "./ADFormComponents/MainTab.vue";
import DubEditorTab from "./ADFormComponents/DubEditorTab.vue";
import NotesAndFilesTab from "./ADFormComponents/NotesAndFilesTab.vue";
import DeliverablesTab from "./ADFormComponents/DeliverablesTab.vue";
import ADFormHierarchy from "./ADFormComponents/ADFormHierarchy.vue";
import ADFormActivity from "./ADFormComponents/ADFormActivity.vue";

// The full tab strip. DUBEDITOR is conditional: only projects flagged as
// DubEditor projects have a fragment workflow, the same flag the Projects form
// uses to show its own DubEditor tab.
const FORM_TABS = [
  { label: "MAIN 📋", component: "MainTab" },
  { label: "NOTES & FILES 📁", component: "NotesAndFilesTab" },
  { label: "DUBEDITOR ✍️", component: "DubEditorTab", requiresDubEditor: true },
  { label: "DELIVERABLES 📦", component: "DeliverablesTab" },
];

// How long an alert stays up before it clears itself.
const ALERT_TIMEOUT = 6000;
// The form closes itself once a save lands, so the success alert needs a beat on
// screen first — without it the confirmation and the modal vanish together.
const SAVE_CLOSE_DELAY = 1400;

export default {
  name: "ADForm",

  components: {
    pmdashboard_table_icons,
    ad_form_icons,
    MainTab,
    DubEditorTab,
    NotesAndFilesTab,
    DeliverablesTab,
    ADFormHierarchy,
    ADFormActivity
  },

  props: {
    staffList: {
      type: Array,
      required: true
    },
    // The dashboard row the form was opened from — used by the Slack shortcut.
    itemToEdit: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      staffHours: [],
      headerDropdownState: false,
      requestTypeDropdown: false,
      assignmentTypeDropdown: false,
      sourceGeoDropdown: false,
      geoDropdown: false,
      searchTargetGeoDropdown: '',
      searchSourceGeoDropdown: '',
      searchRequestTypeDropdown: '',
      searchAssignmentTypeDropdown: '',
      // Which of the three ids the header shows; the values themselves come off
      // the form (see the headerDropdown computed).
      headerIdShown: 'Cue Task ID',
      activeTab: 0,
      isEditing: [],
      isHovered: [],
      windowWidth: window.innerWidth,
      assignmentSettingsMenu: false,
      createdDate: null,
      updatedDate: null,
      createAssignmentLoader: false,
      settingsSection: 'Details',
      // Right column (wide screens) — the rail switches between the assignment's
      // activity and the Task/Assignment hierarchy.
      rightPanelSection: 'Hierarchy',
      // Bumped after a successful save so the activity panel remounts and reads
      // the rows that save just wrote (same mechanism as the task form).
      formActivityUpdate: 0,
      // Serialized form as it was loaded, so leaving for a sibling assignment
      // can warn before dropping edits.
      loadedFormSnapshot: null,
      switchConfirmation: false,
      pendingAssignmentId: null,
      // Closing the card with edits on it asks first — same question the
      // hierarchy switch asks before dropping them.
      closeConfirmation: false,
      // "Delete assignment" from the header menu.
      deleteConfirmation: false,
      deleteProcessing: false,
      // Restricted-edit guard for assignments whose pay period has already been
      // invoiced. `payPeriodIntent` records which action is waiting on the
      // answer; `payPeriodAcknowledged` lets the retry through so the warning is
      // asked once per open assignment, not once per attempt.
      payPeriodWarning: false,
      payPeriodIntent: null,
      payPeriodAcknowledged: false,
      minHeight: 190,
      minWindowHeight: 330,
      // Save feedback shown at the bottom of the card. Kept local rather than in
      // the global flash message so it reads as part of the form, the way the
      // design specifies.
      alert: {
        status: false,
        type: 'success',
        message: '',
      },
      alertTimer: null,
      // Set while a saved form is holding open to show its success alert; also
      // what stops a second save being fired during that window.
      closeTimer: null,
    };
  },

  computed: {
    ...mapGetters("assignment", [
      "geoOptions",
      "mediaTypeOptions",
      "requestTypeOptions",
      "projectsList",
      "assignmentForm",
      "relatedWriters",
      "relatedEditors",
      "reviewers",
      "formValidation"
    ]),
    ...mapGetters("auth", ["user", "isAdmin", "isManager"]),
    // Title bar line: "Created on Sep 2" (plus ", last edited …" when the record
    // was touched on a later day). Empty when the record carries no usable
    // createdDate, so the line renders nothing instead of a bogus date.
    createdOnText() {
      const created = this.parseTitleDate(this.createdDate);
      if (!created) return "";
      const updated = this.parseTitleDate(this.updatedDate);
      const label = `Created on ${this.formatTitleDate(created)}`;
      return updated && updated.toDateString() !== created.toDateString()
        ? `${label}, last edited ${this.formatTitleDate(updated)}`
        : label;
    },
    // Task hierarchy and the activity log are internal views of the record.
    // A staff member gets the assignment itself and nothing around it.
    canEditMainFields() {
      return this.isAdmin || this.isManager;
    },
    canSeeSidePanels() {
      return this.canEditMainFields;
    },
    // A ceiling, not a height: the column is as tall as whichever tab is open
    // and no taller, so a short tab does not trail an empty screen.
    dynamicHeightStyle() {
      const windowHeight = window.innerHeight;
      const calculatedHeight = Math.max(this.minHeight, windowHeight - (this.minWindowHeight - this.minHeight));
      return {
        maxHeight: `${calculatedHeight}px`,
      };
    },
    geoOptionsFiltered() {
      return this.geoOptions.filter(item => item.toLowerCase().includes(this.searchTargetGeoDropdown.toLowerCase()));
    },
    sourceGeoFiltered() {
      return this.geoOptions.filter(item => item.toLowerCase().includes(this.searchSourceGeoDropdown.toLowerCase()));
    },
    requestTypeFiltered() {
      return this.requestTypeOptions.filter((item) =>
        String(item).toLowerCase().includes(this.searchRequestTypeDropdown.toLowerCase())
      );
    },
    assignmentTypeFiltered() {
      return this.requestTypeOptions.filter((item) =>
        String(item).toLowerCase().includes(this.searchAssignmentTypeDropdown.toLowerCase())
      );
    },
    // An assignment that already exists on the server is being edited; a form
    // with no id is still a draft. Derived from the record itself so the header,
    // the Publish/Update button and the save verb can never disagree.
    gIsEditing() {
      return !!this.assignmentForm.id;
    },
    // Whether this assignment's project has a DubEditor workflow at all. The
    // project is hydrated with its full record (getOneProject) both on load and
    // when one is picked, so the flag is available either way.
    dubEditorEnabled() {
      const project = this.assignmentForm.relatedProject;
      return !!(
        project?.dubEditorProject || project?.dubEditor?.fragments?.length
      );
    },
    // DUBEDITOR is only offered for a DubEditor project, so the strip follows
    // whichever project is selected.
    tabs() {
      return FORM_TABS.filter(
        (tab) => !tab.requiresDubEditor || this.dubEditorEnabled
      );
    },
    // True once the form differs from what was loaded. Drives both the
    // [UNSAVED CHANGES] badge and the hierarchy's sibling-switch warning.
    hasUnsavedChanges() {
      if (!this.loadedFormSnapshot) return false;
      return this.loadedFormSnapshot !== this.serializeForm();
    },
    checkIfFieldUpdated() {
      return this.hasUnsavedChanges;
    },
    // The three ids the header can show. Values are read off the form, so they
    // fill in as soon as an assignment is loaded or saved.
    headerDropdown() {
      return [
        {
          title: 'Cue Task ID',
          value: this.assignmentForm.taskId,
          // Belongs to the parent task, so it is not edited from here.
          field: null,
          show: this.headerIdShown === 'Cue Task ID'
        },
        {
          title: 'Cue Assignment ID',
          value: this.assignmentForm.id,
          // This is the record's own id, not a value anyone supplies — the
          // serializer never sends it as a field. Editing it would either be
          // discarded or break the record's identity, so it stays read-only.
          field: null,
          show: this.headerIdShown === 'Cue Assignment ID'
        },
        {
          title: 'External Assignment ID',
          value: this.assignmentForm.externalAssignmentId,
          field: 'externalAssignmentId',
          show: this.headerIdShown === 'External Assignment ID'
        },
      ];
    },
    shownHeaderId() {
      return this.headerDropdown.find((item) => item.show) || this.headerDropdown[0];
    },
    // The Cue Task ID belongs to the task and the Cue Assignment ID is the
    // record's own key — neither is typed by anyone, so neither should light up
    // under the cursor as though it were. They are copied, not edited.
    headerIdEditable() {
      return !!this.shownHeaderId.field && this.canEditMainFields;
    },
    assignmentDetailValue: {
      get() {
        return this.assignmentForm.assignmentDetail;
      },
      set(value) {
        this.updateAssignmentData({ field: "assignmentDetail", data: value });
      },
    },
    assignmentTitleValue: {
      get() {
        return this.assignmentForm.assignmentTitle
      },
      set(value) {
        this.updateAssignmentData({
          field: 'assignmentTitle',
          data: value
        })
      }
    },
  },

  watch: {
    // The strip is addressed by index, so dropping DUBEDITOR would otherwise
    // leave activeTab pointing at a different panel — or past the end of the
    // strip. Picking a project is a deliberate action, so returning to MAIN is
    // the predictable outcome. Only fires on a real change, so a form that never
    // had a DubEditor project is left alone.
    dubEditorEnabled(enabled) {
      if (!enabled) this.activeTab = 0;
    },
  },

  methods: {
    // Reads the hours logged against this assignment. Called on open and again
    // whenever a submission changes, because everything the Work Types table
    // shows for hours — the quantity, the status chip, which row actions are
    // offered — is derived from this list, and it used to be fetched once and
    // then left to go stale behind the user.
    async loadStaffHours() {
      this.staffHours = [];
      if (!this.assignmentForm || !this.assignmentForm.id) return;
      try {
        const resp = await getStaffHoursByAssignmentId(this.assignmentForm.id);
        if (resp.status !== 200) return;
        const hours = resp.data.filter(
          (el) => el.staffId === this.user.user.id || this.user.user.userRole !== "STAFF"
        );
        hours.forEach((el) => {
          this.staffHours.push(...el.workTime);
        });
        this.staffHours.forEach((el) => {
          el.status = hours[0].status;
          el.staffHoursId = hours[0].id;
        });
      } catch (error) {
        console.error(error);
      }
    },
    // A submission, a correction, a review or a delete all land here. The open
    // form refreshes itself before telling the dashboard behind it to refresh.
    async handleStaffHoursChanged() {
      await this.loadStaffHours();
      this.$emit("assignment-dashboard-table-refresh");
    },
    ...mapActions("assignment", [
      "updateAssignmentData",
      "getStaffByGeo",
      "setAssignmentForm",
      "resetAssignmentForm",
      "flagInvalidFields",
      "clearFormValidation"
    ]),
    // True once a publish has been rejected and this field was one of the
    // reasons. Everything keyed off it stays quiet until then, so an untouched
    // draft never opens covered in red.
    isInvalid(field) {
      return !!(this.formValidation.intent && this.formValidation.fields[field]);
    },
    ...mapActions("flashMessage", ["handleFlash"]),
    // createdDate / updatedDate arrive either as an ISO timestamp string
    // ("2026-09-02T07:44:54.521777Z") or as the [year, month, day] array Spring
    // serialises LocalDate into. Returns null for anything unparseable.
    parseTitleDate(value) {
      if (!value) return null;
      const date = Array.isArray(value)
        ? new Date(value[0], value[1] - 1, value[2])
        : new Date(value);
      return isNaN(date.getTime()) ? null : date;
    },
    formatTitleDate(date) {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    },
    formatDateForTitle(value) {
      const date = this.parseTitleDate(value);
      return date ? this.formatTitleDate(date) : '';
    },
    toggleHeaderDropdown() {
      this.headerDropdownState = !this.headerDropdownState;
    },
    toggleRequestTypeDropdown() {
      if (!this.canEditMainFields && !this.requestTypeDropdown) return;
      this.requestTypeDropdown = !this.requestTypeDropdown;
      if (this.requestTypeDropdown) {
        this.searchRequestTypeDropdown = "";
        this.focusDropdownSearch("search-requestTypeDropdown");
      }
    },
    toggleAssignmentTypeDropdown() {
      if (!this.canEditMainFields && !this.assignmentTypeDropdown) return;
      this.assignmentTypeDropdown = !this.assignmentTypeDropdown;
      if (this.assignmentTypeDropdown) {
        this.searchAssignmentTypeDropdown = "";
        this.focusDropdownSearch("search-assignmentTypeDropdown");
      }
    },
    toggleSourceGeoDropdown() {
      if (!this.canEditMainFields && !this.sourceGeoDropdown) return;
      this.sourceGeoDropdown = !this.sourceGeoDropdown;
      if (this.sourceGeoDropdown) {
        this.searchSourceGeoDropdown = "";
        this.focusDropdownSearch("search-sourceGeoDropdown");
      }
    },
    toggleGeoDropdown() {
      if (!this.canEditMainFields && !this.geoDropdown) return;
      this.geoDropdown = !this.geoDropdown;
      if (this.geoDropdown) {
        this.searchTargetGeoDropdown = "";
        this.focusDropdownSearch("search-geoDropdown");
      }
    },
    selectDropdownItem(item) {
      this.headerIdShown = item.title;
      this.headerDropdownState = false;
    },
    selectRequestTypeDropdownItem(item) {
      this.updateAssignmentData({
        field: 'requestType',
        data: item
      });
      this.requestTypeDropdown = false;
    },
    selectSourceGeoDropdownItem(item) {
      this.updateAssignmentData({
        field: 'sourceGeo',
        data: item
      });
      this.sourceGeoDropdown = false;
    },
    selectGeoDropdownItem(item) {
      this.updateAssignmentData({
        field: 'geo',
        data: item
      });
      if (item && this.assignmentForm.relatedProject && this.assignmentForm.relatedProject.name !== 'Empty') this.getStaffByGeo({selectedGeo: item});
      this.geoDropdown = false;
    },
    selectAssignmentTypeDropdownItem(item) {
      this.updateAssignmentData({
        field: 'assignmentType',
        data: item
      });
      this.assignmentTypeDropdown = false;
    },
    // Create (POST) or update (PUT) the assignment, then attach whatever the
    // Notes & Files tab is holding. The record has to exist before the files can
    // be linked to it, so the order here is fixed: save, then upload.
    async publishAssignment() {
      // `closeTimer` covers the beat between a successful save and the form
      // closing — the button is live again by then, so without this a second
      // click would save the same record twice.
      if (this.createAssignmentLoader || this.closeTimer) return;

      const { messages, fields } = validateAssignmentForm(this.assignmentForm);
      if (messages.length) {
        // Cleared and re-raised a tick later so the shake replays on every
        // rejected attempt — re-applying a class the element already carries
        // would not restart the animation.
        this.clearFormValidation();
        this.$nextTick(() => this.flagInvalidFields(fields));
        this.showAlert({ type: 'error', message: messages.join("\n") });
        return;
      }
      this.clearFormValidation();

      // Editing a record from a pay period that has already been invoiced can put
      // the invoice and the record out of step, so the first attempt stops here
      // and asks. Checked after validation, so the warning only interrupts a save
      // that would otherwise have gone through.
      if (this.requiresPayPeriodConfirmation("update")) return;

      // Grabbed before the save: adopting the server response below rebuilds
      // `documents` from the payload, which only knows about files that are
      // already attached. Without this the files the user just picked would be
      // dropped before they ever go up.
      const pendingDocuments = (this.assignmentForm.documents || []).filter(
        (el) => el?.file && !el.uploaded
      );
      // Stored files the Notes & Files tab dropped. Detached only after the record
      // itself saved, so a failed update never destroys a file.
      const removedDocuments = (this.assignmentForm.removedDocuments || []).filter(
        (el) => el?.id
      );
      // The record stores one link; anything past the first is not persisted.
      const droppedLinks = (this.assignmentForm.links || []).slice(1);

      this.createAssignmentLoader = true;
      try {
        const result = await saveAssignmentForm({ form: this.assignmentForm });

        if (!result.ok) {
          // Same field precedence the flash message used, so a rejection the
          // server explains ("an assignment with this ID already exists") still
          // reaches the user in its own words rather than the generic fallback.
          this.showAlert({
            type: 'error',
            message:
              result.response?.data?.message ||
              result.response?.data?.error ||
              "Failed to save the assignment",
          });
          return;
        }

        // Adopt the server's version of the record — the create response carries
        // the new id (and cueTaskId), which the upload and the task sync need —
        // then put the still-pending files back so they can be uploaded.
        if (result.saved) {
          const parsed = parseAssignmentResponse(result.saved);
          // The response predates the detach calls below, so it still lists the
          // files the user removed. They come off here and detachRemovedDocuments
          // puts back any whose removal did not go through.
          const removedIds = removedDocuments.map((el) => el.id);
          parsed.documents = [
            ...parsed.documents.filter((el) => !removedIds.includes(el.id)),
            ...pendingDocuments,
          ];
          this.setAssignmentForm(parsed);
          this.createdDate = result.saved.createdDate ?? this.createdDate;
          this.updatedDate = result.saved.updatedDate ?? this.updatedDate;
        } else if (removedDocuments.length) {
          // Nothing to adopt, so drop the removed rows and clear the queue by
          // hand — otherwise saving again would detach the same files twice.
          const removedIds = removedDocuments.map((el) => el.id);
          this.updateAssignmentData({
            field: "documents",
            data: (this.assignmentForm.documents || []).filter(
              (el) => !removedIds.includes(el.id)
            ),
          });
          this.updateAssignmentData({ field: "removedDocuments", data: [] });
        }

        // These report file trouble through the global flash message, which is a
        // separate channel from the card's own alert and outlives the form — so a
        // save that succeeded while its files did not says both things at once.
        await this.detachRemovedDocuments(removedDocuments);

        if (result.id && pendingDocuments.length)
          await this.uploadPendingDocuments(result.id);

        // Side effects, in the same shape the legacy form uses. Both swallow
        // their own errors — the assignment is already saved.
        await notifyAssignmentSaved({
          form: this.assignmentForm,
          payload: result.payload,
          assignmentId: result.id,
          isUpdate: result.isUpdate,
        });
        await syncParentTaskStatus({
          cueTaskId: result.saved?.cueTaskId ?? this.assignmentForm.cueTaskId,
          status: result.payload.assignmentDetails.assignmentStatus,
        });

        // Nothing is dirty any more, so the [UNSAVED CHANGES] badge and the
        // hierarchy's discard warning clear.
        this.captureFormSnapshot();
        // The save wrote history rows; remount the panel so it shows them.
        this.formActivityUpdate += 1;
        this.$emit("assignment-saved", result.id);

        // Raised only now, after the uploads: a large file can take longer than
        // the alert's own timeout, and an alert started before the wait would
        // have expired before anyone saw it. The dropped-link caveat rides along
        // with the confirmation rather than replacing it.
        this.showAlert({
          type: 'success',
          message: [
            result.isUpdate
              ? "Assignment was updated successfully"
              : "Assignment was published successfully",
            droppedLinks.length
              ? `— only the first link is stored, not saved: ${droppedLinks.join(", ")}`
              : "",
          ]
            .filter(Boolean)
            .join(" "),
        });
        // Hold the card open long enough for that alert to register. The parent
        // reloads the table when the form closes either way, so the only thing
        // this delays is the modal coming down.
        this.closeTimer = setTimeout(() => {
          this.closeTimer = null;
          this.closeForm();
        }, SAVE_CLOSE_DELAY);
      } catch (err) {
        console.error("Assignment save error:", err);
        this.showAlert({
          type: 'error',
          message: err.message || "Failed to save the assignment",
        });
      } finally {
        this.createAssignmentLoader = false;
      }
    },
    // Detach the stored files the Notes & Files tab dropped. The rows are already
    // gone from the form by the time this runs, so a file whose removal did not go
    // through is put back — the list has to show what is actually on the record.
    async detachRemovedDocuments(removedDocuments) {
      if (!removedDocuments.length) return;

      const results = await Promise.all(
        removedDocuments.map(async (document) => {
          try {
            const { ok, error, notSupported } = await detachAssignmentDocument(
              document
            );
            if (ok) return null;
            return {
              document,
              error: notSupported
                ? `${document.fileName} could not be removed — this deployment has no file removal endpoint.`
                : error,
            };
          } catch (err) {
            console.error("Assignment document removal error:", err);
            return {
              document,
              error: err.message || `Failed to remove ${document.fileName}`,
            };
          }
        })
      );

      const failures = results.filter(Boolean);
      if (!failures.length) return;

      this.updateAssignmentData({
        field: "documents",
        data: [
          ...(this.assignmentForm.documents || []),
          ...failures.map((el) => el.document),
        ],
      });
      this.handleFlash({
        response: {
          data: {
            statusCode: 500,
            error: failures.map((el) => el.error).join("\n"),
          },
        },
        show: true,
      });
    },
    // Uploads every document the user added in the Notes & Files tab and
    // connects the stored files to the saved assignment. Documents that are
    // already on the assignment are skipped, so saving twice never re-uploads.
    async uploadPendingDocuments(assignmentId) {
      const documents = this.assignmentForm.documents || [];
      const pendingDocuments = documents.filter((el) => el?.file && !el.uploaded);
      if (!pendingDocuments.length) return;

      // The loader is owned by publishAssignment, which is the only caller.
      try {
        const { attached, failed } = await uploadAndAttachDocuments({
          assignmentId,
          pendingDocuments,
        });
        // Only the files that reached the assignment are marked done; the rest
        // stay pending, so saving again retries just those.
        this.updateAssignmentData({
          field: "documents",
          data: documents.map((el) =>
            attached.includes(el) ? { ...el, file: null, uploaded: true } : el
          ),
        });
        if (failed.length) {
          this.handleFlash({
            response: {
              data: {
                statusCode: 500,
                error: `${attached.length} of ${pendingDocuments.length} files uploaded. Failed: ${failed
                  .map((el) => el.document.fileName)
                  .join(", ")}`,
              },
            },
            show: true,
          });
        } else {
          this.handleFlash({
            response: {
              data: {
                statusCode: 200,
                message: `${attached.length} file(s) uploaded`,
              },
            },
            show: true,
          });
        }
      } catch (err) {
        console.error("Assignment document upload error:", err);
        // Keep the documents pending so the user can save again and retry.
        this.handleFlash({
          response: {
            data: {
              statusCode: 500,
              error: err.message || "Failed to upload the assignment files",
            },
          },
          show: true,
        });
      }
    },
    openSlackForm(item) {
      console.log('openSlackForm', item);
    },
    // Raise the bottom-of-card alert. Replacing one alert with another clears the
    // outgoing timer first, otherwise the earlier fuse would cut the new message
    // short.
    showAlert({ type = 'error', message } = {}) {
      clearTimeout(this.alertTimer);
      this.alert = {
        status: true,
        type,
        message: message || 'Something went wrong',
      };
      this.alertTimer = setTimeout(() => this.closeAlert(), ALERT_TIMEOUT);
    },
    // Also the handler for the alert's own close button — v-alert reports the
    // dismissal through `input`, and the wrapper is what actually hides it.
    closeAlert() {
      clearTimeout(this.alertTimer);
      this.alertTimer = null;
      this.alert.status = false;
    },
    closeForm() {
      this.$emit("close-assignment-form");
    },
    // The one entry point for closing by intent — the header's close button and
    // the dashboard's outside-click / ESC handling both come through here. A form
    // with nothing on it closes straight away, so the common path is unchanged; a
    // dirty one asks first instead of dropping the edits silently.
    requestClose() {
      // A save has already landed and the card is only holding open to show its
      // confirmation. Nothing is at risk, so close on request instead of asking
      // about changes that were just persisted.
      if (this.closeTimer) {
        this.closeForm();
        return;
      }
      if (this.hasUnsavedChanges) {
        this.closeConfirmation = true;
        return;
      }
      this.closeForm();
    },
    cancelClose() {
      this.closeConfirmation = false;
    },
    confirmClose() {
      this.closeConfirmation = false;
      this.closeForm();
    },
    serializeForm() {
      try {
        return JSON.stringify(this.assignmentForm);
      } catch (err) {
        return null;
      }
    },
    // Snapshot the form once it is fully populated — anything typed after this
    // point counts as an unsaved change.
    captureFormSnapshot() {
      this.$nextTick(() => {
        this.loadedFormSnapshot = this.serializeForm();
      });
    },
    // A node was clicked in the hierarchy panel: confirm first when the current
    // assignment has edits, otherwise hand the id to the dashboard to route to.
    handleHierarchySelect(assignmentId) {
      if (!assignmentId) return;
      if (String(assignmentId) === String(this.assignmentForm.id)) return;
      if (this.hasUnsavedChanges) {
        this.pendingAssignmentId = assignmentId;
        this.switchConfirmation = true;
        return;
      }
      this.$emit("select-assignment", assignmentId);
    },
    cancelHierarchySwitch() {
      this.switchConfirmation = false;
      this.pendingAssignmentId = null;
    },
    confirmHierarchySwitch() {
      const assignmentId = this.pendingAssignmentId;
      this.switchConfirmation = false;
      this.pendingAssignmentId = null;
      if (assignmentId) this.$emit("select-assignment", assignmentId);
    },
    openSettingsMenu() {
      this.assignmentSettingsMenu = true;
    },
    closeSettingsMenu() {
      this.assignmentSettingsMenu = false;
    },
    isHoveredOn(item) {
      // The hover chrome only ever advertises an editor and its clear cross.
      if (!this.canEditMainFields) return;
      if (!this.isHovered.includes(item)) {
        this.isHovered.push(item);
      }
    },
    isHoveredOff(item) {
      if (this.isHovered.includes(item)) {
        this.isHovered = this.isHovered.filter((i) => i !== item);
      }
    },
    startEditing(item) {
      if (!this.canEditMainFields) return;
      this.isEditing.push(item);
      this.$nextTick(() => {
        const field = this.$refs[item];
        if (field && typeof field.focus === "function") field.focus();
      });
    },
    // Opening a searchable dropdown should leave you able to type straight
    // away rather than having to click into the box first.
    focusDropdownSearch(refName) {
      this.$nextTick(() => {
        const ref = this.$refs[refName];
        const input = Array.isArray(ref) ? ref[0] : ref;
        if (input && typeof input.focus === "function") input.focus();
      });
    },
    beginEditingHeaderId() {
      if (!this.shownHeaderId.field) return;
      this.startEditing("editableInput-headerId");
    },
    stopEditing(item) {
      if (
        item != "relatedProject" 
        || item != "clientRequester"
        || item != "deliveryDate"
        || item != "requestDate"
      ) {
        this.isEditing = this.isEditing.filter((i) => i !== item);
        this.isHovered = this.isHovered.filter((i) => i !== item);
      }
    },
    // A saved assignment whose pay period closed before the current month has
    // already been invoiced to the client. Drafts and open periods are
    // unrestricted.
    isPayPeriodClosed() {
      if (!this.gIsEditing) return false;
      const payPeriod = toApiPayPeriod(this.assignmentForm.payPeriod);
      if (!payPeriod) return false;
      return payPeriod < this.$moment().format("YYYY-MM");
    },
    // True when the action has to wait on the restricted-edit answer. Raises the
    // dialog as a side effect, so callers just bail out when it returns true.
    requiresPayPeriodConfirmation(intent) {
      if (this.payPeriodAcknowledged) return false;
      if (!this.isPayPeriodClosed()) return false;
      this.payPeriodIntent = intent;
      this.payPeriodWarning = true;
      return true;
    },
    cancelPayPeriodAction() {
      this.payPeriodWarning = false;
      this.payPeriodIntent = null;
    },
    // Proceeding clears the guard for as long as this assignment stays open — the
    // form remounts per record, so the next one asks again — then replays the
    // action that tripped it.
    proceedPayPeriodAction() {
      const intent = this.payPeriodIntent;
      this.payPeriodWarning = false;
      this.payPeriodIntent = null;
      this.payPeriodAcknowledged = true;
      if (intent === "delete") this.confirmDeleteAssignment();
      else this.publishAssignment();
    },
    // "Delete assignment" in the header menu. A draft only exists in the form
    // until it is published, so there is no record to delete and no id to delete
    // it by — say so rather than appearing to do nothing.
    deleteAssignment() {
      this.closeSettingsMenu();

      if (!this.gIsEditing) {
        this.showAlert({
          type: 'error',
          message:
            'This assignment has not been created yet, so there is nothing to delete. Publish it first.',
        });
        return;
      }

      this.deleteConfirmation = true;
    },
    cancelDeleteAssignment() {
      this.deleteConfirmation = false;
    },
    // Confirmed from the dialog. The restricted-edit guard covers deletes too —
    // destroying an invoiced record is worse than editing one.
    async confirmDeleteAssignment() {
      if (this.deleteProcessing) return;
      this.deleteConfirmation = false;

      if (this.requiresPayPeriodConfirmation("delete")) return;

      const id = this.assignmentForm.id;
      if (!id) return;

      this.deleteProcessing = true;
      try {
        const resp = await deleteAssignmentById(id);
        // A request that never reached the server resolves with no response at
        // all, so this tests for a success rather than for a failure — the other
        // way round, a dropped connection would read as "deleted".
        if (!resp || resp.status >= 400) {
          // Kept open on failure so the message has somewhere to be read.
          this.showAlert({
            type: 'error',
            message:
              resp?.data?.message ||
              resp?.data?.error ||
              'Failed to delete the assignment',
          });
          return;
        }
        // Reported through the global flash rather than the card's own alert: the
        // form closes on the next line and the confirmation has to outlive it.
        this.handleFlash({ response: resp, show: true });
        this.$emit("assignment-deleted", id);
        this.closeForm();
      } catch (err) {
        console.error("Assignment delete error:", err);
        this.showAlert({
          type: 'error',
          message: err.message || 'Failed to delete the assignment',
        });
      } finally {
        this.deleteProcessing = false;
      }
    },
    // Copies whichever of the three ids the header is currently showing.
    copyTaskId() {
      const shown = this.headerDropdown.find(item => item.show);
      if (shown?.value) {
        navigator.clipboard.writeText(String(shown.value))
          .then(() => {
            this.handleFlash({ response: {data: {message: "Copied", statusCode: 200}}, show: true });
          })
          .catch(err => {
            console.error('Failed to copy ID:', err);
          });
      } else {
        console.warn('No ID to copy');
      }
    },
    copyAssignmentTitle() {
      if (this.assignmentForm.assignmentTitle) {
        navigator.clipboard.writeText(this.assignmentForm.assignmentTitle)
          .then(() => {
            this.handleFlash({ response: {data: {message: "Copied", statusCode: 200}}, show: true });
          })
          .catch(err => {
            console.error('Failed to copy Name:', err);
          });
      } else {
        console.warn('No Assignment Name to copy');
      }
    },
    copyAssignmentDetail() {
      if (!this.assignmentForm.assignmentDetail) {
        console.warn('No Assignment Detail to copy');
        return;
      }
      navigator.clipboard.writeText(this.assignmentForm.assignmentDetail)
        .then(() => {
          this.handleFlash({ response: {data: {message: "Copied", statusCode: 200}}, show: true });
        })
        .catch(err => {
          console.error('Failed to copy Detail:', err);
        });
    },
    updateHeight() {
      this.windowWidth = window.innerWidth;
      this.$forceUpdate();
    },
    syncAssigneesWithStaffList() {
      // The /assignment payload returns primary/secondary/qc as flat user
      // objects ({ id, firstName, ... }), but the assignee selectors are bound
      // to the project's staff objects (with the user nested under `.user`).
      // Swap in the matching staff instance so the current Primary/Secondary/QC
      // render and remain selectable; keep the original value if no match.
      const matchStaff = (list, person) => {
        if (!person) return null;
        const userId = person.user?.id ?? person.id;
        return list.find((el) => el.user?.id === userId) ?? person;
      };
      const primary = matchStaff(this.relatedWriters, this.assignmentForm.primary);
      const secondary = matchStaff(this.relatedEditors, this.assignmentForm.secondary);
      const qc = matchStaff(this.reviewers, this.assignmentForm.qc);
      if (primary !== this.assignmentForm.primary)
        this.updateAssignmentData({ field: "primary", data: primary });
      if (secondary !== this.assignmentForm.secondary)
        this.updateAssignmentData({ field: "secondary", data: secondary });
      if (qc !== this.assignmentForm.qc)
        this.updateAssignmentData({ field: "qc", data: qc });
    },
  },

  async mounted() {
    window.addEventListener('resize', this.updateHeight);
    // A form that opens (or that the hierarchy swapped to another assignment)
    // starts clean, whatever the previous record failed on.
    this.clearFormValidation();
    const id = this.$route.query.openAssignmentForm;
    if (id) {
      const response = await getAssignmentById(id);
      const parsedData = parseAssignmentResponse(response);
      this.setAssignmentForm(parsedData);
      // Feeds the "Created on … last edited …" line in the title bar.
      this.createdDate = response?.createdDate ?? null;
      this.updatedDate = response?.updatedDate ?? null;
      // Enrich the related project with its staff / client requesters / purchase
      // orders so the Primary, Secondary, QC, Client Requester and PO selectors
      // have options to choose from (the /assignment payload omits these lists).
      const relatedProject = this.assignmentForm.relatedProject;
      if (relatedProject?.id && !relatedProject.staff) {
        const projectResp = await getOneProject(relatedProject.id);
        const projectLoaded =
          projectResp && projectResp.status >= 200 && projectResp.status < 300;
        if (projectLoaded && projectResp.data) {
          this.updateAssignmentData({ field: "relatedProject", data: projectResp.data });
        }
      }
      // Populate the assignee option lists for the currently selected target GEO,
      // then reconcile the loaded Primary/Secondary/QC with those lists.
      if (this.assignmentForm.geo && this.assignmentForm.relatedProject?.staff?.length) {
        this.getStaffByGeo({ selectedGeo: this.assignmentForm.geo });
        this.syncAssigneesWithStaffList();
      }
    }
    await this.loadStaffHours();
    this.captureFormSnapshot();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight);
    // Both fire against a component that is going away — the alert timer if the
    // form is closed while a message is still up, the close timer if the user
    // dismisses the dialog inside the post-save beat.
    clearTimeout(this.alertTimer);
    clearTimeout(this.closeTimer);
    // wipe the form state so the next time the modal opens it starts empty
    // (an existing assignment is re-fetched and re-populated in mounted())
    this.resetAssignmentForm();
  }
};
</script>

<style lang="scss" scoped>
  .assignment-form {
    font-family: 'Roboto', sans-serif !important;
    border-radius: 15px !important;
    position: relative;
    min-height: 90vh;
    max-height: 90vh;
    // Fill the dialog instead of demanding 90vw: the dialog is capped at
    // 1720px, so on wide screens 90vw was wider than its own container and
    // pushed a horizontal scrollbar onto the modal.
    width: 100%;
    // Each column scrolls on its own, so the card itself never shows a
    // scrollbar in either direction.
    overflow: hidden;
    // Save feedback spans the full bottom edge of the card, across both columns,
    // as the design has it. Absolute rather than in flow so raising it never
    // reflows the form underneath.
    &__messages {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      border-radius: 15px !important;
      z-index: 9999;
      .v-alert {
        margin-bottom: 0 !important;
        border-radius: 15px !important;
      }
    }
    &__header {
      &--dropdown {
        position: absolute;
        top: 28px;
        // Was a fixed 150px, which had nothing to do with the three rows it
        // holds — the last one sat outside the card. It takes its own height.
        min-width: 300px;
        width: max-content;
        max-width: 420px;
        background-color: #fff;
        padding: 12px 8px;
        box-shadow: 0px 1px 6px 2px #00000026;
        border-radius: 10px;
        z-index: 20;
        & .dropdown-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 4px;
          padding: 6px 8px;
          border-radius: 6px;
          cursor: pointer;
          &:last-child { margin-bottom: 0; }
          &:hover { background-color: #F5F5F5; }
          .search-container {
            display: flex;
            align-items: center;
            background-color: #f8f9fa;
            border: 1px solid #EDEFF3;
            border-radius: 8px;
            width: 320px;
            height: 36px;
            margin-bottom: 8px;
          }
          .search-container input {
            border: none;
            outline: none;
            background: none;
            flex: 1;
            padding: 8px;
            font-size: 16px;
            color: #697A9B;
          }
          .search-container .icon {
            color: #a0a0a0;
            margin-right: 10px;
            margin-left: 12px;
            font-size: 20px;
            width: 16px;
            height: 16px;
          }
          &--left {
            display: flex;
            flex-direction: column;
            min-width: 0;
            flex: 1 1 auto;
            &--text {
              font-family: 'Inter';
              font-weight: 500;
              font-size: 14px;
              line-height: 16px;
              letter-spacing: 0px;
              margin: 0 0 2px 0;
              color: #656F7D80;
              &.dropdown-item--left--text--geo {
                color: #292a2c !important;
              }
            }
            &--value {
              display: flex;
              align-items: center;
              gap: 6px;
              min-width: 0;
              // The copy button used to sit right on top of the value.
              & .assignment-form--id--button {
                font-size: 14px;
                min-width: 18px !important;
                width: 18px;
                height: 18px;
                padding: 0 !important;
                margin: 0;
                flex: 0 0 auto;
              }
              &--text {
                font-family: 'Roboto';
                font-weight: 600;
                font-size: 16px;
                line-height: 18px;
                vertical-align: middle;
                color: #93979D;
                margin: 0;
              }
            }
          }
          &--right {
            width: 20%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color: #B1B6BD;
          }
        }
        & .dropdown-item.search-container-wrapper {
          flex: 0 0 auto;
          position: sticky;
          top: 0;
          background: white;
          z-index: 10;
          padding: 8px 0 0 0;
        }
        & .dropdown-list {
          flex: 1;
          overflow-y: auto;
        }
        &.dropdown__request {
        max-height: 320px;
        overflow-y: auto;
          height: 250px !important;
          overflow-y: auto;
          z-index: 100 !important;
          position: absolute !important;
            &::-webkit-scrollbar {
              width: 10px;
            }

            &::-webkit-scrollbar-track {
              background: #f1f1f1;
            }

            &::-webkit-scrollbar-thumb {
              background: #ADB3BD;
              border-radius: 8px;
            }

            &::-webkit-scrollbar-thumb:hover {
              background: #ADB3BD;
            }

            & {
              scrollbar-width: thin;
              scrollbar-color: #ADB3BD #f1f1f1;
            }
        }
      }
    }
    &__title {
      font-family: 'Roboto', sans-serif !important;
      border-bottom: 1px solid #e0e0e0;
      min-height: 50px;
      padding: 0 20px;
      p {
        margin: 0;
      }
      &--left {
        font-size: 16px !important;
        font-weight: 600;
        color: #656F7D !important;
      }
      &--right {
        min-width: 40%;
        justify-content: flex-end;
        &--text {
          font-size: 14px !important;
          font-weight: 300;
          color: #656F7D;
        }
        &--publish {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4px;
          background-color: #1976D2;
          border-radius: 5px;
          color: #FFFFFF;
          font-weight: 400;
          font-size: 16px;
          font-family: 'Roboto', sans-serif !important;
          line-height: 18px;
          opacity: 0.9;
          &:hover {
            cursor: pointer;
            opacity: 1;
          }
        }
        &--delimetr {
          width: 1px;
          height: 20px;
          background-color: #e0e0e0;
        }
        &--icon {
          width: 22px;
          height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        &--close {
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover {
            cursor: pointer;
          }
        }
        &--menu {
          position: absolute;
          width: 186px;
          height: 52px;
          padding: 10px 5px 10px 5px;
          border-radius: 10px;
          background: #FFFFFF;
          top: 25px;
          right: 0px;
          box-shadow: 0px 1px 6px 2px #00000026;
          z-index: 20;
          display: flex;
          flex-direction: column;
          justify-content: center;
          &--items {
            padding: 8px 5px 8px 5px;
            border-radius: 4px;
            & p {
              color: #697A9B;
              font-family: 'Roboto', sans-serif !important;
              font-size: 14px;
              font-weight: 500;
              margin-bottom: 0;
              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    &__assignment {
      // Figma 1574-8128: Content Main Part is 1040 wide and centred in the
      // scrollable content, with its inner frames inset 20 — so 1000 of actual
      // content. Applied for every role: the popup is wider for a manager
      // because of the Activity panel, but the content column itself is the
      // same measurement. pa-6 sets its padding with !important, so the inset
      // has to as well.
      &--title--narrow {
        max-width: 1040px;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        padding-left: 20px !important;
        padding-right: 20px !important;
      }
      &--title {
        padding: 25px 35px;
        & .assignment-form {
          &--id {
            font-size: 16px !important;
            font-weight: 600;
            color: #93979D !important;
            margin-bottom: 0px;
            &--text {
              font-size: 16px !important;
              font-weight: 600;
              color: #656F7D80 !important;
              margin-bottom: 0px;
              white-space: nowrap;
            }
            // The label and its caret are one target, so the whole thing
            // responds rather than just the 15px button that used to be there.
            &--switch {
              cursor: pointer;
              border-radius: 4px;
              padding: 0 4px;
              margin-left: -4px;
              transition: background-color 0.15s ease;
              &:hover { background-color: #EDEDED; }
            }
            &--caret {
              margin-left: 4px;
              display: flex;
              align-items: center;
            }
            // The value, not the label, is what you click — so it is the part
            // that looks live.
            &--value {
              font-size: 16px !important;
              font-weight: 600;
              color: #656F7D !important;
              margin-bottom: 0px;
              white-space: nowrap;
              &--editable {
                cursor: pointer;
                border-radius: 4px;
                padding: 0 4px;
                transition: background-color 0.15s ease;
                &:hover { background-color: #EDEDED; }
              }
            }
            &--button {
              min-width: 15px;
              padding: 0 5px;
            }
          }
          &--title {
            // min-height, not height: the headline is now the assignment detail,
            // which runs longer than a title did and has to wrap rather than
            // spill out of a fixed box.
            min-height: 45px;
            &--div {
              font-size: 26px;
              font-weight: 600;
              margin-bottom: 4px;
            }
            &--button {
              min-width: 15px;
              padding: 0 5px;
            }
          }
          // The Assignment Title, now the line under the headline.
          &--subtitle {
            min-height: 24px;
            margin-bottom: 4px;
            &--div {
              font-size: 16px;
              font-weight: 400;
              color: #000000DE;
              margin-bottom: 0;
            }
            &--button {
              min-width: 15px;
              padding: 0 5px;
            }
          }
          &--dri {
            display: flex;
            align-items: center;
            &--text {
              font-size: 16px !important;
              font-weight: 600 !important;
              font-family: 'Roboto', sans-serif !important;
              color: #656F7D;
              margin-bottom: 0px;
            }
            &--circle {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #7C99E2;
              margin-left: 6px;
              margin-right: 6px;
            }
            &--name {
              font-size: 16px !important;
              font-weight: 400 !important;
              color: #000000;
              font-family: 'Roboto', sans-serif !important;
              margin-bottom: 0px;
              &-dash {
                margin: 0;
                margin-left: 6px;
                font-family: Roboto;
                font-size: 16px;
                font-weight: 600;
                color: #B4B4B4 !important;
              }
            }
          }
        }
      }
      &--delimetr-horizontal {
        height: 1px;
        width: calc(100% - 20px);
        background-color: #e0e0e0;
      }
      &--content {
        padding: 0 35px;
        &--assignments {
          &-text {
            font-family: 'Roboto', sans-serif !important;
            font-size: 16px !important;
            font-weight: 400 !important;
            line-height: 18px !important;
            text-align: left !important;
            color: #B4B4B4 !important;
          }
        }
        
        &-left {
          // Flex child: without this, long field values could push the details
          // column past its calc() width and shove the right panel off screen.
          min-width: 0;
          &--text {
            font-size: 16px;
            color: #656F7D;
            margin-bottom: 0px;
            width: 100% !important;
            & .user-status-name {
              display: flex;
              align-items: center;
              &-initials {
                min-width: 36px;
                height: 36px;
                font-size: 16px;
                font-weight: 400;
                color: #fff;
                border-radius: 50%;
                background-color: #9747FF;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              &-text {
                color: #000;
                font-size: 16px !important;
                font-weight: 400 !important;
                font-family: 'Roboto', sans-serif !important;
                & a {
                  color: #0000EE !important;
                }
              }
            }
            & .user-status-pending {
              &-container {
                border: 2px dashed #656F7D;
                color: #656F7D !important;
                padding: 8px 5px;
                width: 80px;
                height: 32px;
                border-radius: 15px;
                font-size: 16px !important;
                font-weight: 400 !important;
                font-family: Roboto !important;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
          &--chips-item {
            font-family: Roboto, sans-serif !important;
            font-size: 16px !important;
            font-weight: 500 !important;
            line-height: 18px !important;
            text-align: left !important;
            border-radius: 5px !important;
            &:hover {
              cursor: pointer;
            }
          }
          &--chip {
            color: #fff !important;
            height: 27px !important;
            margin-left: 8px !important;
          }
          &--autocomplete {
            max-width: 133px;
            font-size: 14px !important;
            & .v-input__control {
              & .v-input__slot {
                max-height: 23px !important;
                padding: 0 !important;
              }
            }
          }
          &--dropdown {
            display: inline-block;
            position: relative;
            width: 180px;
            border-radius: 5px;
            .dropdown-wrapper {
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-radius: 5px;
              padding: 4px;
              cursor: pointer;
            }
            .dropdown-text {
              flex-grow: 1;
              font-size: 16px;
              font-weight: 400;
              color: #656F7D !important;
              font-family: 'Roboto', sans-serif !important;
            }
            .dropdown-arrow {
              background-color: transparent;
              border: none;
              cursor: pointer;
              background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>');
              background-repeat: no-repeat;
              background-position: center;
              background-size: 12px 12px;
              width: 20px;
              height: 20px;
            }
            .dropdown-menu {
              position: absolute;
              top: 100%;
              left: 0;
              right: 0;
              margin: 0;
              padding: 0;
              list-style: none;
              background-color: #fff;
              border: 1px solid #ccc;
              border-radius: 4px;
              max-height: 200px;
              min-width: 200px;
              overflow-y: auto;
              z-index: 1000;
            }
            .dropdown-menu li {
              padding: 10px;
              cursor: pointer;
            }
            .dropdown-menu li:hover {
              background-color: #f0f0f0;
            }
            .background-color {
              background-color: #E8E8E8 !important;
            }
          }
        }
      }
      &--settings {
        width: 60px !important;
        min-height: calc(100% - 200px) !important;
        padding: 10px 8px 0 8px !important;
        border-left: 1px solid #E8EAED !important;
        flex-shrink: 0;
        &--right {
          // In the right column the rail runs the full height of the panel.
          min-height: 100% !important;
        }
        &--button {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 44px;
          height: 44px;
          &:hover {
            cursor: pointer;
          }
          &-icon {
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            padding: 2px;
          }
          & .settings--text {
            font-family: Roboto;
            // Smaller than the PM Dashboard rail so the labels fit the 44px
            // button without wrapping.
            font-size: 11px;
            line-height: 14px;
            font-weight: 400;
            color: #757575;
            white-space: nowrap;
          }
        }
      }
      &--right {
        border-left: 1px solid #E0E0E0;
        flex-shrink: 0;
        overflow: hidden;
        // Takes whatever the 60px rail and the 1px border leave, so the column
        // is exactly 420px wide and nothing spills sideways.
        &--panel {
          flex: 1 1 auto;
          min-width: 0;
        }
        &--placeholder {
          width: 100%;
          height: 80vh;
          display: flex;
          align-items: center;
          justify-content: center;
          & p {
            font-family: Roboto;
            font-size: 16px;
            font-weight: 400;
            line-height: 18px;
            text-align: center;
            color: #B4B4B4;
          }
        }
      }
    }
    &__confirmation-modal {
      background-color: #fff !important;
      width: 500px !important;
      display: flex;
      flex-direction: column;
      padding: 30px;
      border-radius: 10px;
      &--title {
        font-family: 'Roboto', sans-serif !important;
        font-size: 20px;
        font-weight: 500;
        color: #656F7D;
        margin-bottom: 10px;
      }
      &--text {
        font-family: 'Roboto', sans-serif !important;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: #757575;
        margin-bottom: 20px;
      }
      &--buttons {
        &-continue {
          color: #757575 !important;
          text-transform: none !important;
        }
        &-discard {
          color: #FFF !important;
          text-transform: none !important;
        }
      }
    }
    &__tabs {
      width: 100%;
      margin-top: 30px;
      &--buttons {
        display: flex;
        gap: 10px;
        margin-bottom: 15px;
      }
      .tab-btn {
        padding: 10px 16px;
        border: none;
        background: transparent;
        cursor: pointer;
        transition: 0.45s;
        font-family: 'Roboto', sans-serif !important;
        font-weight: 500;
        font-size: 14px;
        text-transform: uppercase;
        color: #0000008A;
        border-bottom: 2px solid transparent;
      }

      .tab-btn.active {
        background: transparent;
        color: #1976D2;
        border-bottom: 2px solid #1976D2;
      }
      &--content {
        width: 100%;
        // Nothing overflows here any more — only the open tab is laid out, so
        // there is no neighbouring panel to clip. Plain `visible` also keeps
        // this from becoming a scroll container, which is what lets the tabs'
        // sticky action bars resolve against .scrollable-col.
        overflow: visible;
        position: relative;
      }
      .tabs-slider {
        display: flex;
        align-items: flex-start;
        width: 100%;
      }
      .tab-panel {
        width: 100%;
        flex-shrink: 0;
        padding: 10px 0;
      }
    }
    &--geo {
      background-color: #E1E1E1;
      height: 18px;
      padding: 2px 3px;
      border-radius: 5px;
      font-family: "Roboto", sans-serif;
      font-weight: 600;
      font-size: 16px;
      color: #656F7D;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .assignment-form__clear {
    width:16px;
    height: 16px;
    padding: 4px;
    border-radius: 2px;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 9000 !important;
    position: absolute !important;
    &--title {
      top: 50%;
      transform: translateY(-45%);
      right: 15px;
    }
    &:hover {
      background-color: #DEDEDE;
      cursor: pointer;
    }
    &--employer {
      top: 50%;
      transform: translateY(-45%);
      right: 6px !important;
    }
  }

  .input-field {
    border: none;
    outline: none;
    width: 100% !important;
    background-color: #F2F2F2;
    padding: 2px 5px;
    &-assignmentDetail {
      padding: 2px 0;
      font-size: 26px;
      font-weight: 600;
    }
    &-assignmentTitle {
      padding: 2px 0;
      font-size: 16px;
      font-weight: 400;
    }
    &-idNumber {
      font-size: 16px !important;
      font-weight: 600 !important;
      padding: 0;
      color: #656F7D !important;
    }
  }

  // "No Detail" / "No Name" are placeholders, not content, and should read as
  // the same grey every other empty field in this form uses.
  .assignment-form--placeholder {
    color: #B4B4B4 !important;
  }

  .bradius-4 {
    border-radius: 4px !important;
  }

  // Rejected-publish feedback, matching the PM Dashboard task form: the label
  // of every field that blocked the save turns red and shakes once. Raised only
  // after a publish attempt, so a blank draft never opens marked up.
  .error-color {
    color: #BE2629 !important;
  }

  // Own keyframes name so this never depends on, or overwrites, the identical
  // one the PM Dashboard task form declares.
  @keyframes assignment-form-shake {
    0%, 100% { transform: translateY(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateY(-7px); }
    20%, 40%, 60%, 80% { transform: translateY(7px); }
  }

  .shake {
    animation: assignment-form-shake 1s ease-in-out;
  }

  // Lays the details column and the right panel side by side (same rule the
  // PM Dashboard task form uses for its two-column layout).
  .row-styles {
    display: flex !important;
    flex-direction: row !important;
  }

  .animated-section {
    animation: fadeIn 0.9s ease forwards;
    opacity: 1;
    transition: opacity 0.9s ease, transform 0.9s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  // The details column scrolls inside itself so the modal never does — same
  // rule as the PM Dashboard task form.
  .scrollable-col {
    // height: auto is not redundant. PMDashboardFormActivity.vue declares
    // `.scrollable-col { height: 330px }` in an UNSCOPED style block, so that
    // rule lands on this element too. The old `height: 80vh !important` here
    // happened to mask it; a bare max-height does not, and the column collapses
    // to 330px. Overridden explicitly rather than by accident.
    height: auto !important;
    max-height: 80vh !important;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative !important;

    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background: #ADB3BD;
      border-radius: 8px;
    }
    & {
      scrollbar-width: thin;
      scrollbar-color: #ADB3BD #f1f1f1;
    }
  }

  .geos--arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 18px;
    margin: 0 4px;
  }
</style>